import { useState, useEffect } from 'react';
import { OPDReportsFetch } from './opdReportsService';
import { useLocation } from 'react-router-dom';

function useOpdReportsHook() {
    const [OpdReportsState, setOpdReportsState]= useState([]);
    const location = useLocation();
    const usersDetails = JSON.parse(sessionStorage.getItem("loginDetails"));

    
    const fetchOpdReports = async () => {
        let ids= {
            userId:  usersDetails?.uniqueID,
            opdId: location?.state?.rowData?.opdid
        }
        try {
            let result = await OPDReportsFetch(ids);
            if (result.status === 200) setOpdReportsState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    
    useEffect(() => {
        fetchOpdReports();
    }, []);

    const handleGetRowId = (e) => {
        return e?.opdid
    }
    return {
        OpdReportsState,
        handleGetRowId

    };
}

export default useOpdReportsHook;
